
<template>
  <div>
    <el-row>
      <el-col :span="17">
        <el-calendar v-model="today">
          <template
            slot="dateCell"
            slot-scope="{date, data}"
          >
            <div style="text-align:left;display:block">
              <p style="margin-bottom:2px;text-align:left">
                <span v-if="data.day===currentDay">今天</span>
                <span v-else>{{ data.day.split('-').slice(2).join('-') }}</span>
                {{ data.isSelected ? '✔️' : '' }}
                <el-tag v-if="getDayFirstTask(data.day,2)" type="primary">{{ getDayFirstTask(data.day,2) }}</el-tag>
              </p>
              <!-- 事件 -->
              <!-- <el-badge v-if="getCnt2(data.day,1)" :value="getCnt2(data.day,1)" class="item" type="primary">
              <i style="font-size:20px" class="el-icon-more-outline" />
            </el-badge> -->
              <!-- 日程 -->
              <!-- <el-badge v-if="getCnt2(data.day,2)" :value="getCnt2(data.day,2)" class="item" style="padding-left:15px" type="warning">
                <i style="font-size:20px" class="el-icon-reading " />
              </el-badge> -->
              <!-- 笔记 -->
              <!-- <el-badge v-if="getCnt2(data.day,3)" :value="getCnt2(data.day,3)" class="item" style="padding-left:15px">
                <i style="font-size:20px" class="el-icon-edit" />
              </el-badge> -->
              <span v-for="(item,idx) in getDayList(data.day,2)" :key="idx" type="primary">
                <el-tag v-if="idx>=1 && idx<=4" type="primary">{{ item }}</el-tag>
              </span>
            </div>
          </template>
        </el-calendar>
      </el-col>
      <el-col :span="7">
        <p style="font-size:40px">{{ dayTitle }}</p>
        <p v-for="(i,idx) in dayList" :key="idx">{{ i.content }}</p>
        <el-row>
          <el-form ref="diaryForm" :model="diaryForm" :rules="diaryRule" label-width="60px" size="small" label-position="right">
            <el-col :span="24">
              <el-form-item label="标题" prop="title">
                <el-input v-model="diaryForm.title" size="small" maxlength="20" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="标签">
                <el-select
                  v-model="diaryForm.TagList"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  size="small"
                >
                  <el-option
                    v-for="item in allTags"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="content" label="内容">
                <el-input
                  v-model="diaryForm.content"
                  clearable
                  type="textarea"
                  :rows="8"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="关联">
                <el-select v-model="diaryForm.relevance" size="small" maxlength="20">
                  <el-option value="1" label="选择任务,作为跟进">选择任务,作为跟进</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="text-align:right">
              <el-button size="small" type="primary" @click="handleAddDiary">保存日记</el-button>
              <el-button size="small" type="primary" @click="handleGoDiaryList">进入日记本</el-button>
            </el-col>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-tabs v-model="activeTabTask">
          <el-tab-pane label="当前任务" name="tabTaskCur">
            <el-form v-model="formTask" label-width="100px" label-position="right">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="参与身份">
                    <Combox
                      v-model="formTask.actionType"
                      type-id="D93"
                      :option-data="getComboxData('D93')"
                      :add-client="false"
                      @handleChange="handleGetTaskData()"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="状态">
                    <Combox
                      v-model="formTask.taskStatus"
                      type-id="D91"
                      :option-data="getComboxData('D91')"
                      :add-client="false"
                      @handleChange="handleGetTaskData()"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-table
              :data="taskListCurrent"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              default-expand-all
              :tree-props="{children: 'children'}"
            >
              <el-table-column prop="workTaskName" label="任务名称" sortable width="180" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleEnterTask(scope.row,1)">{{ scope.row.workTaskName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="ketiInfo.moduleName" label="模块" sortable width="80" :show-overflow-tooltip="true" />
              <el-table-column prop="ketiInfo.projectName" label="课题" sortable width="120" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.ketiInfo" type="text" @click="handleEnterTask(scope.row,2)">{{ scope.row.ketiInfo.projectName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="isAuditByParent" width="50" align="center">
                <template slot-scope="scope">
                  <i v-if="scope.row.isAuditByParent" class="el-icon-star-on" />
                </template>
              </el-table-column>
              <el-table-column prop="beginDateShow" label="开始日期" sortable width="110" />
              <el-table-column prop="endDateShow" label="结束日期" sortable width="110" />
              <el-table-column prop="leaderName" label="负责人" sortable width="100" />
              <el-table-column prop="workTaskStatusDictKeyItemName" label="状态" sortable width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.workTaskStatusDictKeyItemName }}</span>
                  <span v-if="scope.row.auditingType > 0">(审核中)</span>
                </template>
              </el-table-column>
              <el-table-column prop="auditingUserName" label="审核者" sortable width="100" />
              <el-table-column prop="workTaskDescribe" label="任务描述" sortable min-width="180" :show-overflow-tooltip="true" />

              <el-table-column v-if="false" fixed="right" label="操作" width="250" align="center">
                <template slot-scope="scope">
                  <span>
                    <el-button type="text" size="mini" plain @click.stop="handleTaskFollow( scope.row.id,scope.row.parentId)">跟进</el-button>
                    <el-button type="text" size="mini" plain @click.stop="handleAdd( null,scope.row.id)">添加子任务</el-button>
                    <el-button v-if="scope.row.isHasPermAudit" type="text" size="mini" plain @click.stop="handleTaskAudit( scope.row.id,scope.row.parentId)">审核</el-button>
                  </span>
                </template>
              </el-table-column>

            </el-table>

          </el-tab-pane>
          <el-tab-pane v-if="false" label="当天任务" name="tabTaskToday">
            <el-form v-model="formTask" label-width="100px" label-position="right">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="参与身份">
                    <Combox
                      v-model="formTask.actionType"
                      type-id="D93"
                      :option-data="getComboxData('D93')"
                      :add-client="false"
                      @handleChange="handleGetTaskData()"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="状态">
                    <Combox
                      v-model="formTask.taskStatus"
                      type-id="D91"
                      :option-data="getComboxData('D91')"
                      :add-client="false"
                      @handleChange="handleGetTaskData()"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-table
              :data="taskListToday"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              default-expand-all
              :tree-props="{children: 'children'}"
            >
              <el-table-column prop="workTaskName" label="任务名称" sortable width="180" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleEnterTask(scope.row,1)">{{ scope.row.workTaskName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="ketiInfo.moduleName" label="模块" sortable width="80" :show-overflow-tooltip="true" />
              <el-table-column prop="ketiInfo.projectName" label="课题" sortable width="120" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.ketiInfo" type="text" @click="handleEnterTask(scope.row,2)">{{ scope.row.ketiInfo.projectName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="isAuditByParent" width="50" align="center">
                <template slot-scope="scope">
                  <i v-if="scope.row.isAuditByParent" class="el-icon-star-on" />
                </template>
              </el-table-column>
              <el-table-column prop="beginDateShow" label="开始日期" sortable width="110" />
              <el-table-column prop="endDateShow" label="结束日期" sortable width="110" />
              <el-table-column prop="leaderName" label="负责人" sortable width="100" />
              <el-table-column prop="workTaskStatusDictKeyItemName" label="状态" sortable width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.workTaskStatusDictKeyItemName }}</span>
                  <span v-if="scope.row.auditingType > 0">(审核中)</span>
                </template>
              </el-table-column>
              <el-table-column prop="auditingUserName" label="审核者" sortable width="100" />
              <el-table-column prop="workTaskDescribe" label="任务描述" sortable min-width="180" :show-overflow-tooltip="true" />

              <el-table-column v-if="false" fixed="right" label="操作" width="250" align="center">
                <template slot-scope="scope">
                  <span>
                    <el-button type="text" size="mini" plain @click.stop="handleTaskFollow( scope.row.id,scope.row.parentId)">跟进</el-button>
                    <el-button type="text" size="mini" plain @click.stop="handleAdd( null,scope.row.id)">添加子任务</el-button>
                    <el-button v-if="scope.row.isHasPermAudit" type="text" size="mini" plain @click.stop="handleTaskAudit( scope.row.id,scope.row.parentId)">审核</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="日程" name="tabWorkTaskSche">
            <el-tabs v-model="activeTabSche" tab-position="left" @tab-click="handleScheSelect">

              <el-tab-pane label="我执行的" name="tabSche01">
                <el-form v-model="searchFormSche1" label-width="80px" label-position="right">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="任务名称">
                        <el-input v-model="searchFormSche1.workTaskName" clearable @change="handleGetWorkTaskScheData1()" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="状态">
                        <el-select v-model="searchFormSche1.scheStatusDictKey" clearable @change="handleGetWorkTaskScheData1()">
                          <el-option
                            v-for="item in getComboxData('D99')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="workTaskScheData1"
                  class="table-list"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column label="开始时间" prop="scheDateTimeStartShow" width="104px" sortable />
                  <el-table-column label="结束时间" prop="scheDateTimeEndShow" width="104px" sortable />
                  <el-table-column label="任务名称" prop="scheName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="执行者" prop="operUserName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="所属任务" prop="taskInfo.workTaskName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="负责人" prop="taskInfo.leaderName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="状态" prop="scheStatusDictName" width="80px" sortable />
                  <el-table-column label="完成时间" prop="scheCompleteDTShow" width="102px" sortable />
                  <el-table-column label="操作" width="102px">
                    <template slot-scope="scope">
                      <el-button type="success" size="mini" @click="handleExecSche(scope.row)">执行</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="任务日程" name="tabSche02">
                <el-form v-model="searchFormSche2" label-width="80px" label-position="right">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="任务名称">
                        <el-input v-model="searchFormSche2.workTaskName" clearable @change="handleGetWorkTaskScheData2()" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="状态">
                        <el-select v-model="searchFormSche2.scheStatusDictKey" clearable @change="handleGetWorkTaskScheData2()">
                          <el-option
                            v-for="item in getComboxData('D99')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="执行者">
                        <el-select v-model="searchFormSche2.operUserId" clearable @change="handleGetWorkTaskScheData2()">
                          <el-option
                            v-for="item in ketiMemberList"
                            :key="item.userKey"
                            :label="item.userName"
                            :value="item.userKey"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="workTaskScheData2"
                  class="table-list"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column label="开始时间" prop="scheDateTimeStartShow" width="104px" sortable />
                  <el-table-column label="结束时间" prop="scheDateTimeEndShow" width="104px" sortable />
                  <el-table-column label="任务名称" prop="scheName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="执行者" prop="operUserName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="所属任务" prop="taskInfo.workTaskName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="负责人" prop="taskInfo.leaderName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="状态" prop="scheStatusDictName" width="80px" sortable />
                  <el-table-column label="完成时间" prop="scheCompleteDTShow" width="102px" sortable />
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="团队日程" name="tabSche03">
                <el-form v-model="searchFormSche3" label-width="80px" label-position="right">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="任务名称">
                        <el-input v-model="searchFormSche3.workTaskName" clearable @change="handleGetWorkTaskScheData3()" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="状态">
                        <el-select v-model="searchFormSche3.scheStatusDictKey" clearable @change="handleGetWorkTaskScheData3()">
                          <el-option
                            v-for="item in getComboxData('D99')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="执行者">
                        <el-select v-model="searchFormSche3.operUserId" clearable @change="handleGetWorkTaskScheData3()">
                          <el-option
                            v-for="item in ketiMemberList"
                            :key="item.userKey"
                            :label="item.userName"
                            :value="item.userKey"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="workTaskScheData3"
                  class="table-list"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column label="开始时间" prop="scheDateTimeStartShow" width="104px" sortable />
                  <el-table-column label="结束时间" prop="scheDateTimeEndShow" width="104px" sortable />
                  <el-table-column label="任务名称" prop="scheName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="执行者" prop="operUserName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="所属任务" prop="taskInfo.workTaskName" min-width="150px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="负责人" prop="taskInfo.leaderName" width="100px" :show-overflow-tooltip="true" sortable />
                  <el-table-column label="状态" prop="scheStatusDictName" width="80px" sortable />
                  <el-table-column label="完成时间" prop="scheCompleteDTShow" width="102px" sortable />
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <WorkEventNodeFollow
      v-model="nodeFollowShow"
      :node-key="nodeKey"
      :follow-type="followType"
      @save-success="handleReload"
    />
    <WorkTaskScheExec ref="exec" :entity-id="scheId" :task-id="scheTaskId" :module-code="scheModuleCode" :module-key="scheModuleKey" @save-success="handleGetWorkTaskScheData1()" />
  </div>
</template>

<script>
// import note from './headerCalendarNote'
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
// import HeaderCalendarNoteEdit from './headerCalendarNoteEdit'
import WorkEventNodeFollow from '@/views/managesystem/gz/com/WorkEventNodeFollow'
import Combox from '@/views/managesystem/gz/com/Combox'
import WorkTaskScheExec from '@/views/managesystem/gz/com/WorkTaskScheExec'

export default {
  components: {
    // HeaderCalendarNoteEdit,
    WorkEventNodeFollow, Combox,
    WorkTaskScheExec
  },
  props: {},
  data() {
    return {
      title: '日历',
      today: new Date(),
      strToday: '',
      currentDay: this.formatTime(new Date(), 'yyyy-MM-dd'),
      stryyyyMM: '',
      allData: [],
      dayTitle: '',
      dayList: [],
      selectedDate: { type: String, default: null },
      activeTab: 'tab03',
      activeTabOld: '',
      cnt1: null,
      cnt2: null,
      cnt3: null,
      list1: [],
      list2: [],
      list3: [],
      editNoteFormShow: false,
      editNoteEntityKey: null,
      editNoteDefaultDay: null,
      nodeKey: null,
      followType: null,
      nodeFollowShow: false,
      activeTabTask: 'tabWorkTaskSche',
      allComboxData: [],
      formTask: {
        dt: this.strToday,
        actionType: '', // 参与身份
        taskStatus: '' // 状态
      },
      taskListCurrent: [],
      taskListToday: [],
      diaryForm: {
        TagList: []
      },
      diaryRule: {
        title: [
          { required: true, message: '请输入标题', trigger: 'change,blur' }
        ],
        content: [
          { required: true, message: '日记内容不能为空', trigger: 'change,blur' }
        ]
      },
      allTags: [], // 所有标签
      activeTabSche: 'tabSche01',
      workTaskScheData1: [],
      workTaskScheData2: [],
      workTaskScheData3: [],
      searchFormSche1: {
        today: null,
        workTaskName: '',
        operUserId: null,
        scheStatusDictKey: ''
      },
      searchFormSche2: {
        today: null,
        workTaskName: '',
        operUserId: null,
        scheStatusDictKey: ''
      },
      searchFormSche3: {
        today: null,
        workTaskName: '',
        operUserId: null,
        scheStatusDictKey: ''
      },
      ketiMemberList: [],
      scheId: null,
      scheTaskId: null,
      scheModuleCode: '',
      scheModuleKey: null

    }
  },
  computed: {
  },
  watch: {
    today(newVal, oldVal) {
      const strNewVal = this.formatTime(newVal, 'yyyy-MM-dd')
      const strOldVal = this.formatTime(oldVal, 'yyyy-MM-dd')
      const strNewyyyyMM = this.formatTime(newVal, 'yyyyMM')
      this.strToday = strNewVal
      // 月变化，重新取得后台数据
      if (strNewyyyyMM !== this.stryyyyMM) {
        this.handleSearchAllData()
        this.stryyyyMM = strNewyyyyMM
      }
      // 日变化，改变右边的数据
      if (strNewVal !== strOldVal) {
        this.strToday = strNewVal
        this.dayTitle = strNewVal
        this.formTask.dt = strNewVal
        // alert('日期切换')
        this.initRightData()
        this.handleGetTaskData()
        this.handleReflashScheData()
      }
    }
  },
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D91;D93;D99').then(res => {
      this.allComboxData = res.data.result
    })
    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm(
      'api/services/app/Com/GetKetizuMember'
    ).then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  activated() {
    this.stryyyyMM = this.formatTime(this.today, 'yyyyMM')
    this.strToday = this.formatTime(this.today, 'yyyy-MM-dd')
    this.dayTitle = this.strToday
    this.handleSearchAllData()
    this.getAllDiaryTags()
  },
  mounted() {
    // this.$nextTick(() => { alert('点击') })
  },
  init: {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /** 取得所有数据 */
    handleSearchAllData() {
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getForm(
        'api/services/app/Com/GetAllCalendarList2',
        { dt: this.strToday }
      ).then(resp => {
        this.allData = resp.data.result
        this.initRightData()
        this.handleGetTaskData()
        loading.close()
      })
    },

    /** 取得数量 */
    getCnt2(day, type) {
      // console.log(day, type)
      var ret = this.allData.filter(x => {
        return x.dt === day && x.type === type
      })
      if (ret.length > 0) {
        return ret[0].cnt
      } else {
        return 0
      }
    },
    getDayFirstTask(day, type) {
      var list = this.getDayList(day, type)
      if (list) {
        return list[0]
      } else {
        return ''
      }
    },
    /** 取得当天的任务列表 */
    getDayList(day, type) {
      var ret = this.allData.filter(x => {
        return x.dt === day && x.type === type
      })
      if (ret.length > 0) {
        return ret[0].taskNameShorts
        // return ret[0].taskNameShorts
      } else {
        return []
      }
    },
    /** 日程中点击Tab */
    handleScheSelect(tab) {
      if (tab.name === 'tabSche01') {
        this.handleGetWorkTaskScheData1()
      }
      if (tab.name === 'tabSche02') {
        this.handleGetWorkTaskScheData2()
      }
      if (tab.name === 'tabSche03') {
        this.handleGetWorkTaskScheData3()
      }
    },
    /** 格式化时间 */
    formatTime(date, pFmt) {
      // var date = new Date(date)
      if (/(y+)/.test(pFmt)) {
        pFmt = pFmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(pFmt)) {
          var str = o[k] + ''
          pFmt = pFmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
      }
      return pFmt
    },
    /** 右边数据赋值 */
    initRightData() {
      this.cnt1 = this.getCnt2(this.strToday, 1)
      this.cnt2 = this.getCnt2(this.strToday, 2)
      this.cnt3 = this.getCnt2(this.strToday, 3)

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getForm(
        '/api/services/app/Com/GetAllCalendarDetail',
        { dt: this.strToday }
      ).then(resp => {
        this.list1 = resp.data.result.list1
        this.list2 = resp.data.result.list2
        this.list3 = resp.data.result.list3

        this.activeTabOld = this.activeTab
        this.activeTab = ''
        this.activeTab = this.activeTabOld

        loading.close()
      })
    },
    /** 增加日记 */
    handleNoteAdd() {
      this.editNoteFormShow = true
      this.editNoteEntityKey = null
      this.editNoteDefaultDay = new Date()
    },
    /** 编辑日记 */
    handleEditNote(id) {
      this.editNoteFormShow = true
      this.editNoteEntityKey = id
      this.editNoteDefaultDay = null
    },
    /** 重新刷数据 */
    handleReload() {
      this.handleSearchAllData()
    },
    /** 查看事件 */
    handleEventRowClick(row) {
      this.$router.push({
        name: row.str10 + 'dtl',
        params: {
          id: row.str9,
          moduleCode: row.str10
        }
      })
    },
    /** 节点跟进 */
    handleEventNodeRowClick(row) {
      this.nodeKey = row.id
      this.followType = 2
      this.nodeFollowShow = true
    },
    handleGetTaskData() {
      const that = this
      // GetCalendarTask
      pathReq.getForm(
        '/api/services/app/Com/GetCalendarTask', this.formTask
      ).then(r => {
        that.taskListCurrent = r.data.result.taskListCurrent
        that.taskListToday = r.data.result.taskListToday
      })
    },
    /** 进入任务
     * type 1:进入任务 2:进入课题
    */
    handleEnterTask(row, enterType) {
      var ketiInfo = {}
      if (this.activeTabTask === 'tabTaskToday') {
        ketiInfo = this.getProjectInfo(this.taskListToday, row.id)
      } else {
        // tabTaskCur
        ketiInfo = this.getProjectInfo(this.taskListCurrent, row.id)
      }

      if (!ketiInfo) {
        return
      }
      if (enterType === 1) {
        this.$router.push({
          name: ketiInfo.moduleCode + 'dtl',
          params: {
            id: ketiInfo.moduleKey,
            moduleCode: ketiInfo.moduleCode,
            activeName: 'WorkTask'
          }
        })
      } else if (enterType === 2) {
        this.$router.push({
          name: ketiInfo.moduleCode + 'dtl',
          params: {
            id: ketiInfo.moduleKey,
            moduleCode: ketiInfo.moduleCode
          }
        })
      }
    },
    /** 取到最父层的ProjectInfo */
    getProjectInfo(list, id) {
      // var firstLevel = list.find(item => {
      //   return item.id === id
      // })
      // if (firstLevel) {
      //   return firstLevel.ketiInfo
      // }

      var projectInfo = {}
      for (const item of list) {
        if (item.id === id) {
          projectInfo = item.ketiInfo
          break
        } else {
          var isInChildren = this.keyInChild(item.children, id)
          if (isInChildren) {
            projectInfo = item.ketiInfo
            break
          }
        }
      }
      return projectInfo
    },
    /** 递归判断是否 */
    keyInChild(list, id) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]

        if (item.id === id) {
          return true
        } else if (item.children) {
          return this.keyInChild(item.children, id)
        }
      }
    },
    /** 保存日记 */
    handleAddDiary() {
      this.$refs['diaryForm'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/note/CreateOrUpdatenote'

          // that.diaryForm.noteDay = that.strToday 不填的话,后台默认为当天
          that.diaryForm.fenLeiDictKey = 'D8501'// 默认为日记
          pathReq.postForm(path, { entityData: that.diaryForm }).then(res => {
            that.$message.success('日记保存成功')
            that.diaryForm.TagList = []
            that.$refs['diaryForm'].resetFields()
          }).then(_ => {
            that.handleSearchAllData()
          }).then(_ => {
            that.getAllDiaryTags()
          })
        }
      })
    },
    /** 进入日记本 */
    handleGoDiaryList() {
      this.$router.push({
        name: 'diarylist'
      })
    },
    getAllDiaryTags() {
      const that = this
      // GetCalendarTask
      pathReq.getForm('/api/services/app/note/GetAllDiaryTags').then(r => {
        that.allTags = r.data.result
      })
    },
    handleReflashScheData() {
      if (this.activeTabSche === 'tabSche01') {
        this.handleGetWorkTaskScheData1()
      } else if (this.activeTabSche === 'tabSche02') {
        this.handleGetWorkTaskScheData2()
      } else if (this.activeTabSche === 'tabSche03') {
        this.handleGetWorkTaskScheData3()
      }
    },
    handleGetWorkTaskScheData1() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      that.searchFormSche1.today = this.strToday
      pathReq.getForm(
        'api/services/app/Com/GetWorkTaskScheData01',
        that.searchFormSche1
      ).then(resp => {
        that.workTaskScheData1 = resp.data.result
        loading.close()
      })
    },
    handleGetWorkTaskScheData2() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      that.searchFormSche2.today = this.strToday
      pathReq.getForm(
        'api/services/app/Com/GetWorkTaskScheData02',
        that.searchFormSche2
      ).then(resp => {
        that.workTaskScheData2 = resp.data.result
        loading.close()
      })
    },
    handleGetWorkTaskScheData3() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      that.searchFormSche3.today = this.strToday
      pathReq.getForm(
        'api/services/app/Com/GetWorkTaskScheData03',
        that.searchFormSche3
      ).then(resp => {
        that.workTaskScheData3 = resp.data.result
        loading.close()
      })
    },
    /** 执行日程 */
    handleExecSche(row) {
      this.scheId = row.id
      this.scheTaskId = row.taskId
      this.scheModuleCode = row.taskInfo.moduleCode
      this.scheModuleKey = row.taskInfo.moduleKey

      this.$refs.exec.show()
    }
  }
}
</script>
<style scoped lang="scss">
.el-calendar-day{
  height: 65px !important;
}
.is-today{
  border: 5px;
}
.el-tag{
  height: 22px !important;
  line-height: 20px !important;
  margin:0px 2px 2px 0px;
  padding: 1px 4px 1px 4px;
}
</style>
